<template>
    <info-screen
            class="startRegistration"
            :title="$ml.get('setPinCodeTitleReg')"
            :text="$ml.get('setPinCodeTextReg')"
            :action="nextScreen"
            :buttonText="$ml.get('setPinCodeButtonReg')"
            :titleH1="false"
    >
    </info-screen>
</template>

<script>
    import InfoScreen from "../../../components/layout/info-screen";
    import Profile from "../../../helpers/profile";
    export default {
        name: "infoSetPinCodePage",
        components: {InfoScreen},
        created() {
            let isMobile = window.innerWidth < 600;
            if (!isMobile) {
                if (Profile.process === 'login')
                    this.$router.replace('/login/setPinCodeAll');
                else if (Profile.process === 'accessRecovery')
                    this.$router.replace('/accessRecovery/setPinCodeAll');
                else
                    this.$router.replace({ name: 'RegistrationSetPinCodeAll'});
            }
        },
        methods: {
            nextScreen: function () {
                if (Profile.process === 'login')
                    this.$router.push('/login/setPinCode');
                else if (Profile.process === 'accessRecovery')
                    this.$router.push('/accessRecovery/setPinCode');
                else
                    this.$router.push({ name: 'RegistrationSetPinCode'});
            }
        }
    }
</script>

<style scoped>

</style>